import React, { useContext, useEffect, useState } from 'react';
import LocationPerformance from '../../Components/Operations/Monitor/LocationPerformance';
import OpClamps from '../../Components/Operations/Monitor/OpClamps';
import OpSessions from '../../Components/Operations/Monitor/OpSessions';
import OpStatistics from '../../Components/Operations/Monitor/OpStatistics';
import SessionEndRequests from '../../Components/Operations/Monitor/SessionEndRequests';
import PageContainer from '../../Components/Layout/PageContainer';
import FieldContext from '../../Context/FieldContext';
import dictionary from '../../utils/dictionary';
import OperationContext from '../../Context/OperationContext';

const OperationMonitorPage = () => {

    const { getSessionList, getLiveClamps } = useContext(FieldContext);
    const [refreshRate, setRefreshRate] = useState(1);
    const { loadOperations, spaceAvailability} = useContext(OperationContext);

   useEffect(() => {
      loadOperations();
  }, []); // runs on mount (and if loadOperations ref changes)

    

    useEffect(()=>{
           getSessionList();
           getLiveClamps();
            loadOperations(true);
        }, [refreshRate])
    
        useEffect(()=>{
    
            setTimeout(() => {
                setRefreshRate(refreshRate + 1)
            }, dictionary._fieldRefreshRate);
    
        }, [refreshRate])

 
  return (
    <PageContainer>
      <div className="row mt-3">
        <OpStatistics />
      </div>

      <SessionEndRequests />

      <div className="row row-sm">
        <OpSessions />
        <OpClamps />
        <LocationPerformance />
      </div>
    </PageContainer>
  );
};

export default OperationMonitorPage;
